<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="spaces"
        data-cy="spaces-nav-item"
        class="nav-option"
        :to="{ name: 'SpacesList' }"
        :class="{ selected, expanded }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <spaces-nav-icon />
        </div>
        <div
            v-show="expanded"
            class="nav-label">
            <div class="label-text">
                {{ label }}
            </div>
            <pendo-tag
                type="beta"
                size="small" />
        </div>
    </pendo-router-link>
</template>

<script>
import SpacesNavIcon from '@/side-nav/components/nav-icons/spaces-nav-icon.vue';
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTag, PendoTooltip } from '@pendo/components';

export default {
    name: 'SpacesNavItem',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        PendoTag,
        SpacesNavIcon,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.label;
        },
        label () {
            return this.$t('spaces.Spaces');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
